import {
  AttributeDefinitionMutationResult,
  ProductAttributeDefinition,
  ProductAttributeValue,
} from '@features/catalog/models/product-attribute-definition.models';
import {
  GraphqlMutationAttributeDefinitionPayloadDto,
  GraphqlProductAttributeDefinitionDto,
  GraphqlProductAttributeValueDto,
} from '../dto/product-attribute-definition.dto';
import { normalizeGraphqlErrors } from './graphql-error.mapper';

export function mapAttributeValueDto(dto: GraphqlProductAttributeValueDto): ProductAttributeValue {
  return {
    id: String(dto.id),
    value: dto.value,
    position: dto.position ?? null,
    active: dto.active ?? true,
  };
}

export function mapProductAttributeDefinitionDto(dto: GraphqlProductAttributeDefinitionDto): ProductAttributeDefinition {
  const rawValues = dto.productAttributeValues ?? [];
  return {
    id: String(dto.id),
    companyId: dto.companyId != null ? String(dto.companyId) : null,
    name: dto.name,
    slug: dto.slug?.trim() ?? '',
    active: dto.active ?? true,
    position: dto.position ?? null,
    productsCount: dto.productsCount ?? null,
    values: rawValues.map(mapAttributeValueDto),
  };
}

export function asDefinitionDtoArray(
  raw:
    | GraphqlProductAttributeDefinitionDto
    | GraphqlProductAttributeDefinitionDto[]
    | null
    | undefined
): GraphqlProductAttributeDefinitionDto[] {
  if (raw == null) {
    return [];
  }
  return Array.isArray(raw) ? raw : [raw];
}

export function mapMutationDefinitionPayload(
  payload?: GraphqlMutationAttributeDefinitionPayloadDto | null
): AttributeDefinitionMutationResult {
  if (!payload) {
    return { definition: null, errors: ['Respuesta vacía del servidor'] };
  }
  const errors = normalizeGraphqlErrors(payload.errors);
  const definition = payload.definition ? mapProductAttributeDefinitionDto(payload.definition) : null;
  return { definition, errors };
}
